import httpClient from '../httpClient';

export function normalizeCallCredentials(response) {
    const agora = response?.agora;
    const strings = [response?.callId, agora?.appId, agora?.channelName, agora?.rtcToken, agora?.rtmToken];
    if (strings.some(value => typeof value !== 'string' || !value.trim()) ||
        !Number.isInteger(agora?.uid) || agora.uid < 0 || agora.uid > 4294967295 ||
        typeof agora.isAudio !== 'boolean' || typeof agora.isVideo !== 'boolean' ||
        (!agora.isAudio && !agora.isVideo) ||
        !Number.isFinite(agora.expiresAtMillis) || agora.expiresAtMillis <= Date.now()) {
        throw Object.assign(new Error('Invalid call credentials'), { retryable: false });
    }
    return {
        callId: response.callId,
        appId: agora.appId,
        channel: agora.channelName,
        token: agora.rtcToken,
        uid: agora.uid,
        rtmToken: agora.rtmToken,
        isAudio: agora.isAudio,
        isVideo: agora.isVideo,
        expiresAtMillis: agora.expiresAtMillis,
    };
}

export const realSignaling = {
    supportsStatusPolling: false,
    supportsTokenRenewal: false,

    async startCall({ visitorSessionId, residentId, entranceId, coordinates }) {
        if (!/^visitor-\d{19}$/.test(visitorSessionId || '')) throw new Error('Invalid visitor session');
        const baseURL = process.env.VUE_APP_QR_INTERCOM_API_URL?.trim();
        if (!baseURL) throw new Error('QR intercom API URL is missing');
        if (typeof entranceId !== 'string' || !entranceId.trim()) throw new Error('QR intercom id is missing');
        if (typeof residentId !== 'string' || !residentId.trim()) throw new Error('QR resident id is missing');
        if (!coordinates || ![coordinates.latitude, coordinates.longitude, coordinates.accuracy].every(Number.isFinite) ||
            Math.abs(coordinates.latitude) > 90 || Math.abs(coordinates.longitude) > 180 || coordinates.accuracy < 0) {
            throw new Error('Visitor location is invalid');
        }
        const { data } = await httpClient(baseURL)({
            method: 'POST',
            url: '/access/qr-intercom/calls',
            timeout: 15000,
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            data: {
                visitorSessionId,
                latitude: coordinates.latitude,
                longitude: coordinates.longitude,
                accuracy: coordinates.accuracy,
                intercomId: entranceId,
                residentPublicId: residentId,
            },
        });
        return normalizeCallCredentials(data);
    },

    getStatus: async () => null,
    hangup: async () => {},
    renewToken: async () => null,
};

export const getRtmConfig = credentials => ({
    appId: credentials.appId,
    userId: String(credentials.uid),
    token: credentials.rtmToken,
    channelName: credentials.channel,
    messageChannelName: credentials.channel,
    callId: credentials.callId,
    channelType: 'MESSAGE',
    useStringUserId: process.env.VUE_APP_AGORA_RTM_USE_STRING_USER_ID !== 'false',
});

export const getCallSignaling = () => realSignaling;
